import io, { Socket } from 'socket.io-client'
export interface SocketServiceOptions {
    // server location
    url?: string
    // sub path for sockect connection
    path?: string
    // Connection token for socket server
    token?: string
    // Roles for 2nd and 3rd participants
    role?: 'dispatcher' | 'observer'
}

class SocketService {
    socket: typeof Socket | null = null
    private pendingListeners: { channel: string, callback: Function }[] = []

    defaultOptions: SocketServiceOptions = {
        token: '',
        url: '',
        path: '',
    }

    connect(connectOptions: SocketServiceOptions) {
        const options = { ...this.defaultOptions, ...connectOptions }
        // @ts-ignore
        this.socket = io(options.url, {
            path: options.path,
            query: {
                token: options.token,
                ...(options.role ? { role: options.role } : {})
            }
        })
        for (const { channel, callback } of this.pendingListeners) {
            // @ts-ignore
            this.socket.on(channel, callback)
        }
        this.pendingListeners = []
    }

    join(channel: string){
        // @ts-ignore
        this.socket.emit('join', channel)
    }

    emit(channel: string, data: any) {
        // @ts-ignore
        this.socket.emit(channel, data)
    }

    on(channel: string, callback: Function): void {
        if (!this.socket) {
            this.pendingListeners.push({ channel, callback })
            return
        }
        // @ts-ignore
        this.socket.on(channel, callback)
    }

    close() {
        if (this.socket) {
            // @ts-ignore
            this.socket.close()
            this.socket = null
        }
    }

    disconnect(){
        if (this.socket){
            this.socket.disconnect()
            this.socket = null
        }
    }

    off(channel: string, callback?: Function): void {
        this.pendingListeners = this.pendingListeners.filter(
            l => !(l.channel === channel && (!callback || l.callback === callback))
        )
        if (this.socket) {
            // @ts-ignore
            this.socket.off(channel, callback)
        }
    }

    disconnectPermanently() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket.io.opts.reconnection = false;
            this.socket.io.opts.reconnectionAttempts = 0;
            this.socket = null;
        }
    }
}

export default new SocketService()

// Add this at the very bottom of socket.service.ts
export function createObserverSocket(token: string): SocketService {
    const svc = new SocketService();
    svc.connect({
        token,
        role: 'observer'
    });
    return svc;
}
